import { AdditionalInfoSectionProps } from '@gcportal/base';

export const additionalInfoSections: AdditionalInfoSectionProps[] = [
  {
    title: 'News',
    flexGrow: 1,
  },
  {
    title: 'Latest Activity',
    flexGrow: 2,
  },
];
